import Portal from './PortalCompat';
import PortalWithState from './PortalWithState';

export { Portal, PortalWithState };


//////////////////
// WEBPACK FOOTER
// ./~/react-portal/es/index.js
// module id = 814
// module chunks = 0